import { createContext, useContext } from 'react';
import type { Storefront } from '@kitup/brand';

/**
 * The brand's storefront pages, provided next to the brand and its legal bundle.
 *
 * No default value, like `LegalContext`: another brand's landing on this brand's
 * domain is worse than a loud failure.
 */
export const StorefrontContext = createContext<Storefront | null>(null);

export function useStorefront(): Storefront {
  const storefront = useContext(StorefrontContext);
  if (!storefront) throw new Error('BrandProvider is missing above this component in the tree');
  return storefront;
}
